import { RouterProvider } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { router } from "./services/Router";
import { Theme } from "./styles/theme";

// Este QueryClient serve APENAS o ReactQueryDevtools abaixo, que fica fora
// do RouterProvider. Todo o resto do app roda sob o QueryClient criado em
// services/Router.tsx dentro de RootLayout - o provider mais interno vence,
// e RootLayout e o elemento de rota mais externo, ou seja, o app inteiro.
//
// Consequencia pratica, escrita aqui porque ja custou tempo: ajustar
// staleTime, retry ou qualquer default NESTE objeto nao tem efeito nenhum
// sobre as consultas do app. O arquivo a editar e services/Router.tsx.
// Nao apague este objeto: sem ele o devtools fica sem client.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 15,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Theme>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
      </Theme>
    </QueryClientProvider>
  );
}

export default App;
